import { render, staticRenderFns } from "./send-test-message-dialog.vue?vue&type=template&id=eb71d564&"
import script from "./send-test-message-dialog.vue?vue&type=script&lang=js&"
export * from "./send-test-message-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports